// extracted by mini-css-extract-plugin
module.exports = {"halfImage":"halfImage_halfImage__2YV3z","invert":"halfImage_invert__315CI","text":"halfImage_text__3zv4v","shift":"halfImage_shift__-3n7X","pic":"halfImage_pic__1K1-k"};